import { z } from "zod";
import { createSelectValidator } from "../Inputs/Utils/createSelectValidator";

const CategoryValues = ["Select", "Other", "Electrical", "Mechanical", "Plumbing", "Fire Protection"] as const

export const CategorySchema = z.object({
    category: createSelectValidator(
        z.enum(CategoryValues),
        "Category is required"
    ).refine((value) => value?.value !== "Select", {
        message: "Category is required",
    })
})